import { esLocale, esNumberFormats } from './es';
const messages = { es: esLocale };
const numberFormats = { es: esNumberFormats };
export const Locales = { messages, numberFormats };
